import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class RoleRedirectService {

  constructor(
    private readonly router: Router,
  ) { }

  // Siempre toma el primer elemento del arreglo de roles
  private getMainGroup(data: any): string {
    const group = data?.group;

    if (!Array.isArray(group) || group.length === 0) {
      return '';
    }

    return String(group[0]).toUpperCase();
  }

  // Mapa plano grupo→ruta. NOTARIA + `flowProduce === 'ACTIVO'` →
  // 'produce/dashboard' sigue deshabilitado.
  private static readonly ROUTE_BY_GROUP: Record<string, string> = {
    NOTARIA: 'digital/kanban-followup-digital',
    KAM: 'kams/charts',
    LASER: 'laser/constitutions',
    FOLLOW_UP: 'followup/constitutions',
    ADMIN: 'back-office/managment-notary',
    BOMBERO: 'bomberos/stage-management',
    CSA: 'csa/charts',
    ASISTENTE_BCP: 'asistente-administrativo/tickets-bcp',
    PIVOT: 'pivot/customer-incidents',
  };

  async redirectByRole(data: any): Promise<void> {
    const route = RoleRedirectService.ROUTE_BY_GROUP[this.getMainGroup(data)];

    if (route) {
      this.router.navigate([route]);
      localStorage.setItem('isLoggedIn', JSON.stringify(true));
    }
  }
}
